import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { METHODOLOGY } from "@/data/content";

export default function MethodologySteps({ detailed = false }) {
  if (detailed) {
    return (
      <div data-testid="methodology-detailed" className="border-y border-oxford/10 divide-y divide-oxford/10">
        {METHODOLOGY.map((s, i) => (
          <Reveal key={s.title} delay={Math.min(i * 0.05, 0.3)}>
            <div className="group relative grid md:grid-cols-12 gap-6 items-center py-10 lg:py-12 px-2 md:px-6 transition-colors duration-300 hover:bg-bone">
              <span className="absolute left-0 top-0 h-full w-[2px] bg-gold scale-y-0 group-hover:scale-y-100 transition-transform duration-300 origin-top" />
              <div className="md:col-span-2">
                <div className="hexagon w-16 h-[72px] bg-oxford flex items-center justify-center transition-colors duration-300 group-hover:bg-gold">
                  <s.icon className="h-6 w-6 text-gold transition-colors duration-300 group-hover:text-oxford" strokeWidth={1.5} />
                </div>
              </div>
              <div className="md:col-span-4">
                <span className="font-display text-sm font-semibold text-gold">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="mt-1 font-display text-xl lg:text-2xl font-semibold uppercase tracking-wide text-oxford">{s.title}</h3>
              </div>
              <p className="md:col-span-6 text-sm lg:text-base leading-relaxed text-carbon/70">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="methodology-steps" className="relative">
      <div className="hidden lg:block absolute top-7 left-7 right-7 h-px bg-oxford/10" />
      <motion.div
        className="hidden lg:block absolute top-7 left-7 right-7 h-px bg-gold origin-left"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
      />
      <ol className="grid gap-10 lg:grid-cols-6 lg:gap-6">
        {METHODOLOGY.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <li className="relative flex lg:flex-col gap-5">
              {i < METHODOLOGY.length - 1 && (
                <span className="lg:hidden absolute left-[27px] top-16 bottom-[-40px] w-px bg-oxford/10" />
              )}
              <div className="relative z-10 h-14 w-14 shrink-0 rounded-full bg-oxford ring-1 ring-gold/50 flex items-center justify-center font-display text-sm font-semibold text-gold">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div>
                <h3 className="font-display text-sm font-semibold tracking-[0.15em] uppercase text-oxford">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-carbon/70">{s.desc}</p>
              </div>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  );
}
